import React from 'react';
import { ASSESSMENT_STATUS } from '../../../models/AssessmentsModel';
import { LibraryRowMenu, archivedTipId } from '../Library/LibraryDocumentMenu';

/**
 * An assessment's three-dot menu (PRD-1703), the Library's row menu. The
 * actions follow the status: Uploading has none (no trigger), Queued,
 * Processing and Completed can be archived, Failed can be retried or archived,
 * and an archived assessment can only be unarchived.
 *
 * `actions` holds the page's handlers: onRetry, onArchive, onUnarchive.
 */
function AssessmentMenu({ assessment, actions: handlers }) {
  const allowed = ASSESSMENT_STATUS[assessment.status]?.actions || [];
  const actions = [];
  if (assessment.archived) {
    actions.push({ key: 'unarchive', label: 'Unarchive', run: handlers.onUnarchive });
  } else {
    if (allowed.includes('retry')) actions.push({ key: 'retry', label: 'Retry', icon: 'arrows-clockwise', run: handlers.onRetry });
    if (allowed.includes('archive')) actions.push({ key: 'archive', label: 'Archive', danger: true, run: handlers.onArchive });
  }
  if (!actions.length) return null;

  return (
    <LibraryRowMenu
      item={assessment}
      actions={actions}
      anchorProps={{ 'data-asm-menu': assessment.id }}
      ariaDescribedBy={assessment.archived ? archivedTipId(assessment) : undefined}
    />
  );
}

export default AssessmentMenu;
